import { render, staticRenderFns } from "./Bench_work.vue?vue&type=template&id=272d1ef1&"
import script from "./Bench_work.vue?vue&type=script&lang=js&"
export * from "./Bench_work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports